module.exports = __webpack_public_path__ + "img/27-small.b127b13d.png";